export const SET_NOTIFICATION_BAR = 'notificationStatusBar/SET_NOTIFICATION_BAR';
export const CLOSE_NOTIFICATION_BAR = 'notificationStatusBar/CLOSE_NOTIFICATION_BAR';
